<template>
	<div>
		<layout-1 :table_name="'Vessels'" :id=pageid :searchbar=true :navbar=true :nav_items="['Add Vessel']" :nav_item_perms="['31']" :button_perm="'19'" :button_name="'Edit'" :term=term :reroute="'/0305'" :select_reroute=true style="width:100%; height:calc(100vh - 50px);"></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.VESSELS_PAGE
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Vessels.vue